<template>
  <div>
    <div class="spinner-cover-new" v-show="loading">
      <div class="spinner"></div>
    </div>
    <top-bar/>
    <div class="container-fluid">
      <div class="row">
        <details-side-tabs/>
        <details-right-tab/>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsSideTabs from './DetailsSideTabs'
import DetailsRightTab from './DetailsRightTab'
import {mapState} from 'vuex'
import TopBar from './TopBar'

export default {
  data () {
    return {
      loading: false
    }
  },
  mounted() {

  },
  components: {
    TopBar,
    DetailsSideTabs,
    DetailsRightTab
  },
  computed: {
    ...mapState({
      doc: state =>  state.photoDocumentation.newDocumentDetails,
      photoDetails: state =>  state.photoDocumentation.photoDetailsPage,
    })
  },
  created () {
    if (!this.doc.reporttype){
      this.$router.push({name: 'photoDocumentation',params: {id:this.$route.params.id}});
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/CreatePhotoDocument.vue